<div class="camera-preview-container">
  @if (cameraError) {
    <div class="error-message">
      <mat-icon>error</mat-icon>
      <span>{{ cameraError }}</span>
    </div>
  }

  @if (!cameraError) {
    <div class="camera-view">
      <video id="camera-video" playsinline autoplay></video>
      <canvas id="camera-canvas" hidden></canvas>
      <div class="camera-controls">
        <!-- Camera Selection (if multiple cameras available) -->
        @if (showCameraSelection) {
          <div class="camera-selection">
            <abc-select-box
              [label]="this.res?.get('CameraPreview_List')"
              [dataSource]="cameraDevices"
              [displayExpr]="'displayText'"
              (onValueChanged)="onCameraDeviceChange()"
              [(value)]="selectedCameraDevice"
            >
            </abc-select-box>
          </div>
        }
        <abc-button class="controls" (click)="capture()" [text]="this.res?.get('CameraPreview_Capture')"> </abc-button>
      </div>
    </div>
  }
</div>
